import { QueryHookOptions, QueryResult, useQuery } from '@apollo/client';

import AppModule from '../../../app/lib/AppModule';
import appManager from '@app/appManager';
import { getAbandonedCallsBadgeCountFilters } from '@pages/urgentfollowups/AbandonedCallsPage/utils/filters';
import {
  AbandonedCallFollowUpFilterInput,
  AbandonedCallsCountQuery,
  Exact,
  InputMaybe,
} from '@api/generated/graphql';
import { GET_ABANDONED_CALL_FOLLOW_UPS_COUNT_QUERY } from './data/count';

let queryResult: QueryResult<
  AbandonedCallsCountQuery,
  Exact<{
    filter?: InputMaybe<AbandonedCallFollowUpFilterInput>;
  }>
>;

export function useAbandonedCallsCountQuery() {
  const options: QueryHookOptions = {
    variables: {
      filter: getAbandonedCallsBadgeCountFilters(),
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    // Once a minute should be fine for updating the sidenav badge.
    pollInterval: 60_000,
  };

  queryResult = useQuery(GET_ABANDONED_CALL_FOLLOW_UPS_COUNT_QUERY, options);

  return {
    error: queryResult.error,
    previousCount: queryResult.previousData?.abandonedCallFollowUps?.totalCount,
    currentCount: queryResult.data?.abandonedCallFollowUps?.totalCount,
  };
}

class AbandonedCallsModule extends AppModule {
  override events = ['abandonedcall.update'];

  override preload(): void {
    this.app.events.on('abandonedcall.update', () => {
      this.app.logger.info('trigger ABCL refresh');
      queryResult?.refetch();
    });
  }
}

export default new AbandonedCallsModule(
  appManager.events,
  appManager.logger('AbandonedCallsCount'),
);
